import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "700px",
    outline: "none",
  },
  card: {
    borderRadius: "20px",
    overflow: "hidden",
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "24px",
  },

  // Header
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "500",
    color: theme.palette.text.primary,
  },
  closeButton: {
    minWidth: "unset",
    padding: "6px",
    color: theme.palette.text.primary,
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },

  // Stepper
  stepper: {
    backgroundColor: "transparent",
    padding: "0 0 16px",
    // Align the connector line vertically with the step icons
    "& .MuiStep-root": {
      padding: 0,
    },
    "& .MuiStepConnector-root": {
      alignSelf: "center",
    },
    "& .MuiStepLabel-label": {
      color: "#F9F9F9",
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: "#F9F9F9",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "#F9F9F9",
    },
    "& .MuiStepLabel-label.Mui-disabled": {
      color: "#F9F9F9",
    },
    "& .MuiStepIcon-root": {
      color: "#606479",
    },
    "& .MuiStepIcon-text": {
      fill: "#F9F9F9",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: "#6C65D9",
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "#6C65D9",
      borderColor: "red",
    },
    "& .MuiStepConnector-line": {
      borderColor: "#606479",
    },
  },
  stepIcon: {
    width: "28px",
    height: "28px",
  },
  stepIconActive: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    color: "#fff",
  },
  stepLabelRoot: {
    // Override MUI default flex-column to row so label sits beside the icon
    flexDirection: "row !important",
    alignItems: "center !important",
    gap: "8px",
  },
  stepLabel: {
    color: `${theme.palette.text.tertiary} !important`,
    fontSize: "13px !important",
    marginTop: "0 !important",
    paddingTop: "0 !important",
  },

  // Upload area
  uploadArea: {
    width: "100%",
    height: "140px",
    border: `2px dashed ${theme.palette.text.tertiary}`,
    borderRadius: "10px",
    backgroundColor: theme.palette.secondary.light,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "border-color 0.2s, background-color 0.2s",
    "&:hover": {
      borderColor: theme.palette.secondary.main,
    },
  },
  uploadAreaDragging: {
    borderColor: theme.palette.secondary.main,
    backgroundColor: `${theme.palette.secondary.main}18`,
  },
  uploadPlaceholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    pointerEvents: "none",
  },
  uploadIcon: {
    color: theme.palette.secondary.main,
  },
  uploadText: {
    fontSize: "13px",
    color: theme.palette.text.tertiary,
  },

  // File preview (after upload)
  filePreview: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    padding: "0 16px",
  },
  fileIcon: {
    color: theme.palette.secondary.main,
    flexShrink: 0,
  },
  fileName: {
    flex: 1,
    fontSize: "14px",
    color: theme.palette.text.primary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileSize: {
    fontSize: "12px",
    color: theme.palette.text.tertiary,
    margin: "0px 0px 6px 0px",
  },
  removeFileBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.tertiary,
    padding: "4px",
    borderRadius: "6px",
    flexShrink: 0,
    "&:hover": {
      color: "#e53935",
      backgroundColor: "rgba(229,57,53,0.12)",
    },
  },

  //Define Mappings
  headerCell: {
    background: "#252A38 !important",
    color: "#F9F9F9 !important",
    border: `1px solid ${theme.palette.secondary.light} !important`,
  },
  tableCell: {
    color: `#B1B5C9 !important`,
    border: `1px solid ${theme.palette.secondary.light} !important`,
  },
  lightText: {
    color: `#B1B5C9 !important`,
  },
  // Summary Step
  summaryContainer: {
    display: "flex",
    width: "100%",
    gap: "10px",
  },
  summaryColumn: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  summaryColumnHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "10px",
  },
  summaryColumnTitle: {
    fontSize: "14px !important",
    color: "#F9F9F9 !important",
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    backgroundColor: "#252A38",
    borderRadius: "5px",
    marginBottom: "10px",
    fontSize: "14px !important",
    fontWeight: "400 !important",
  },

  // Footer
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  backButton: {
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    textTransform: "none",
    fontWeight: "600",
    padding: "7px 12px",
    borderRadius: "8px",
    fontSize: "14px",
    border: `2px solid ${theme.palette.secondary.main}`,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  nextButton: {
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
    textTransform: "none",
    fontWeight: "600",
    padding: "7px 28px",
    borderRadius: "8px",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  nextButtonDisabled: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
    color: `${theme.palette.text.tertiary} !important`,
  },
  backButtonDisabled: {
    opacity: "0.4 !important",
  },
}));

export default useStyles;
